import { Link } from "react-router-dom";
import { Waveform } from "@/components/Waveform";
import { ArrowUpRight } from "lucide-react";

const PARTICIPANT = [
  { to: "/", title: "Consent screen", desc: "Anonymity notice, opt-in capture toggle, Begin" },
  { to: "/fallback/capped", title: "Spend cap reached", desc: "Graceful 'come back later' when the daily/monthly cap is hit" },
  { to: "/fallback/maintenance", title: "Kill switch / resting", desc: "Maintenance message shown to participants" },
  { to: "/fallback/offline", title: "Offline", desc: "Queued input, cached responses" },
];

const ADMIN = [
  { to: "/admin/login", title: "Admin login", desc: "Email/password or Google Workspace" },
  { to: "/admin", title: "Overview", desc: "KPIs, sessions, spend, grounding rate" },
  { to: "/admin/personality", title: "Personality Studio", desc: "5 sliders, Try-It sandbox, version history with rollback" },
  { to: "/admin/corpus", title: "Memory", desc: "Drive connector, ingestion statuses, chunk preview & exclusion" },
  { to: "/admin/guardrails", title: "Guardrails", desc: "Kill switch, spend caps, rate limits, moderation log" },
  { to: "/admin/evaluation", title: "Evaluation (Phase 3 preview)", desc: "Gate scores, golden set, blocked vs deployed runs — illustrative for now" },
];

const Card = ({ to, title, desc, i }) => (
  <Link to={to} data-testid={`mockup-link-${to.replace(/\//g, "-").slice(1) || "root"}`} className={`rise rise-${(i % 4) + 1} group flex items-start justify-between gap-4 rounded-2xl border border-white/[0.06] bg-[#1A1D21] p-5 transition-colors hover:border-[#E07A5F]/50 hover:bg-[#E07A5F]/5`}>
    <div>
      <p className="font-display text-base font-medium">{title}</p>
      <p className="mt-1 text-sm text-[#6E7582]">{desc}</p>
    </div>
    <ArrowUpRight size={18} className="shrink-0 text-[#6E7582] transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-[#F4A261]" />
  </Link>
);

export default function MockupIndex() {
  return (
    <div className="grain relative min-h-screen bg-[#121417] text-[#F3EFE6]" data-testid="mockup-index">
      <div className="relative z-10 mx-auto max-w-6xl px-6 py-14 md:px-10">
        <p className="eyebrow rise">Griot · internal screen index</p>
        <h1 className="rise rise-1 mt-3 max-w-2xl font-display text-4xl font-semibold leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">A voice that only speaks from what the Lab remembered.</h1>
        <p className="rise rise-2 mt-4 max-w-xl text-base text-[#A1A8B3]">Every screen in one place, for your own reference. Participants and curators start at the root — this page is not linked from anywhere.</p>
        <div className="rise rise-2 -mx-6 mt-4 md:-mx-10"><Waveform state="reflecting" height={180} /></div>

        <div className="mt-6 grid gap-10 lg:grid-cols-2">
          <section>
            <div className="mb-4 flex items-baseline justify-between"><h2 className="font-display text-lg font-medium">Participant PWA</h2><span className="font-mono text-xs text-[#6E7582]">mobile-first</span></div>
            <div className="grid gap-3">{PARTICIPANT.map((c, i) => <Card key={c.to} {...c} i={i} />)}</div>
          </section>
          <section>
            <div className="mb-4 flex items-baseline justify-between"><h2 className="font-display text-lg font-medium">Admin Console</h2><span className="font-mono text-xs text-[#6E7582]">desktop</span></div>
            <div className="grid gap-3">{ADMIN.map((c, i) => <Card key={c.to} {...c} i={i} />)}</div>
          </section>
        </div>
      </div>
    </div>
  );
}
